/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li1Inputs */

const tr_onbilgi_s2_li1 = /** @type {(inputs: Onbilgi_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çoklu pazaryeri yönetim platformu (Trendyol, Shopify, n11 ve diğer entegre platformlar)`)
};

const en_onbilgi_s2_li1 = /** @type {(inputs: Onbilgi_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi marketplace management platform (Trendyol, Shopify, n11 and other integrated platforms)`)
};

const de_onbilgi_s2_li1 = /** @type {(inputs: Onbilgi_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform zur Verwaltung mehrerer Marktplätze (Trendyol, Shopify, n11 und weitere integrierte Plattformen)`)
};

const ru_onbilgi_s2_li1 = /** @type {(inputs: Onbilgi_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа управления несколькими маркетплейсами (Trendyol, Shopify, n11 и другие интегрированные платформы)`)
};

/**
* | output |
* | --- |
* | "Multi marketplace management platform (Trendyol, Shopify, n11 and other integrated platforms)" |
*
* @param {Onbilgi_S2_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li1 = /** @type {((inputs?: Onbilgi_S2_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li1(inputs)
	if (locale === "de") return de_onbilgi_s2_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li1(inputs)
	return tr_onbilgi_s2_li1(inputs)
});